import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import useHome from "@hooks/useHome";

import WPSideNav from "@components/WPSideNav";

import { resetActiveFolder } from "@features/home/ViewAllFolderSlice";
import { setSideMenu, updateActiveMenu } from "@features/menu/SideMenuSlice";

import { resetFilterConfig, setSearchValue, updateLoader } from "../CardListSlice";

import { FoldersBreadcrumbData, HomeSideNavMenu } from "./HomeSideNav.constants";
import HomeSideNavFolders from "./HomeSideNavFolders";
import HomeSideNavItem from "./HomeSideNavItem";

import "./HomeSideNav.scss";

const HomeSideNav = () => {
  const dispatch = useDispatch();

  const UserInfoStore = useSelector(state => state.userInfo.data);
  const { activeMenu } = useSelector(state => state.leftpanel);

  const userID = UserInfoStore ? UserInfoStore.UserId : 1;

  const [isFolderOpened, setIsFolderOpened] = useState(false);

  const { getFolderListData } = useHome();

  useEffect(() => {
    if (userID) {
      getFolderListData();
    }
  }, [userID]);

  const handleMenuItemClick = optionId => {
    dispatch(updateActiveMenu(optionId));
    dispatch(updateLoader(false));
    let breadcrumbData = null;
    if (optionId === "folders") {
      const isFolderView = !isFolderOpened;
      setIsFolderOpened(isFolderView);
      breadcrumbData = FoldersBreadcrumbData;
    }
    dispatch(setSideMenu({ breadcrumbData }));
    dispatch(resetActiveFolder());
    dispatch(setSearchValue(""));
    dispatch(resetFilterConfig());
  };

  return (
    <>
      <WPSideNav className='home-side-nav-container' top={60}>
        <div className='project_navigation_menu'>
          <ul className='project_navigation_menu_list'>
            {HomeSideNavMenu.map(menuOption => (
              <HomeSideNavItem
                menuOption={menuOption}
                key={menuOption.id}
                selectedOption={activeMenu}
                onClick={handleMenuItemClick}
                isFolderOpened={isFolderOpened}
              />
            ))}
          </ul>
        </div>
        {isFolderOpened && <HomeSideNavFolders />}
      </WPSideNav>
    </>
  );
};

export default HomeSideNav;
